import i18n from '@/i18n';
import { taskAPI } from '@/utils/api';
import { buildRetryTaskApiPatch } from './ipeTaskActions';

function readImageUrlsFromTaskResult(result) {
  const r = result && typeof result === 'object' ? result : {};
  const fromUrls = Array.isArray(r.referenceUrls) ? r.referenceUrls.filter(Boolean) : [];
  if (fromUrls.length > 0) return fromUrls;
  const fromPreviews = Array.isArray(r.referencePreviews) ? r.referencePreviews.filter(Boolean) : [];
  return fromPreviews;
}

/** AI 扩图历史重试：重新入队服务端 Worker */
export async function retryAiOutpaintTask(task) {
  const taskId = String(task?.id || '').trim();
  if (!taskId) throw new Error(i18n.t('workbench:ipeUtilError.taskInvalid'));

  const r = task?.result && typeof task.result === 'object' ? task.result : {};
  const rawRefs = readImageUrlsFromTaskResult(r);
  if (rawRefs.length === 0) {
    throw new Error(i18n.t('workbench:ipeUtilError.taskMissingOutpaintSource'));
  }

  // 扩图固定 1 原图 → 1 结果（忽略历史任务里可能残留的 generateCount>1）
  const estimatedTotal = Math.max(1, rawRefs.length);
  const apiPatch = buildRetryTaskApiPatch({
    total: estimatedTotal,
    successCount: 0,
    failedCount: 0,
  });

  await taskAPI.update(taskId, {
    ...apiPatch,
    result: {
      ...r,
      generateCount: 1,
      serverWorker: true,
      batchPhase: 'queued',
      outputs: [],
      urls: [],
      processedSourceIndices: [],
      failureHint: '',
    },
  });
  await taskAPI.submit(taskId, { force: true });
  return { taskId };
}

/** AI 文生图历史重试：重新入队服务端 Worker */
export async function retryAiTextToImageTask(task) {
  const taskId = String(task?.id || '').trim();
  if (!taskId) throw new Error(i18n.t('workbench:ipeUtilError.taskInvalid'));

  const r = task?.result && typeof task.result === 'object' ? task.result : {};
  const prompt = String(r.prompt || '').trim();
  if (!prompt) {
    throw new Error(i18n.t('workbench:ipeUtilError.taskMissingPrompt'));
  }

  const outputCount = Math.max(1, Math.min(4, Number(r.outputCount ?? task.total ?? 1) || 1));
  const apiPatch = buildRetryTaskApiPatch({
    total: outputCount,
    successCount: 0,
    failedCount: 0,
  });

  await taskAPI.update(taskId, {
    ...apiPatch,
    result: {
      ...r,
      prompt,
      style: r.style,
      aspectRatio: r.aspectRatio,
      outputCount,
      serverWorker: true,
      batchPhase: 'queued',
      outputs: [],
      urls: [],
      failureHint: '',
    },
  });
  await taskAPI.submit(taskId, { force: true });
  return { taskId };
}
